/**
 * Gift Service - Public gifted-membership claim lookups (no auth)
 */

import api from './api';

export const getGift = (code) => api.get(`/gift/${code}`);
